/**
 * Matches Rust `updater_finish_download` errors when `update.apk` is missing or unusable.
 * In those cases the deferred-install record should be cleared so a fresh download can run.
 */
export function isDeferredApkCacheInvalidError(message: string): boolean {
  const m = message.toLowerCase()
  return (
    m.includes('apk file missing')
    || m.includes('apk file is empty')
    || m.includes('missing after download')
  )
}
